module.exports = __webpack_public_path__ + "static/img/tjbgfeng.9c0db95.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/tjbgfeng.jpg
// module id = EWkl
// module chunks = 9